import { useQuery } from 'react-query';
import { getMedication } from 'App/services/AdminService';

function useFetchMedicationQuery(medicationName) {
    return useQuery(['admin', 'medication', medicationName], () => getMedication(medicationName), {
        enabled: !!medicationName,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchMedicationQuery;
